import sortBy from 'lodash/sortBy';
import isardsatLogo from './images/isardsat-logo.png';
import rnmitLogo from './images/rnmi-logo.png';
import fmiLogo from './images/fmi-logo.png';
import vitoLogo from './images/vito-logo.png';
import draxisLogo from './images/draxis-logo.png';
import vizzualityLogo from './images/vizzuality-logo.png';

export const partnersData = sortBy([
  {
    id: 'isardsat',
    name: 'isardsat',
    url: 'http://www.isardsat.co.uk/',
    logo: isardsatLogo,
    height: 13,
    width: 92,
    description: 'isardSAT is an R&D enterprise that provides services and solutions in the Earth Observation field.',
    index: 0
  },
  {
    id: 'rnmi',
    name: 'Royal netherlands metrological institute',
    url: 'http://www.knmi.nl',
    logo: rnmitLogo,
    height: 31,
    width: 134,
    description: 'The Dutch meteorological institute is the national research and information centre for meteorology, climate, air quality, and seismology.',
    index: 2
  },
  {
    id: 'fmi',
    name: 'Finish metrological institute',
    url: 'http://en.ilmatieteenlaitos.fi/',
    logo: fmiLogo,
    height: 48,
    width: 79,
    description: 'The Finnish Meteorological Institute (FMI) is a research and service agency that provides the best possible information about the atmosphere.',
    index: 1
  },
  {
    id: 'vito',
    name: 'vito',
    url: 'https://vito.be/en',
    logo: vitoLogo,
    height: 26,
    width: 85,
    description: 'Leading European independent research and technology organisation in the areas of cleantech and sustainable development.',
    index: 3
  },
  {
    id: 'draxis',
    name: 'Draxis',
    url: 'http://draxis.gr',
    logo: draxisLogo,
    height: 39,
    width: 105,
    description: 'Draxis provides comprehensive Environmental Management solutions and Environmental IT.',
    index: 4
  },
  {
    id: 'vizzuality',
    name: 'Vizzuality',
    url: 'http://www.vizzuality.com/',
    logo: vizzualityLogo,
    height: 21,
    width: 84,
    description: 'Vizzuality creates unique tools and applications with a lasting benefit to society and the environment.',
    index: 5
  }
], p => p.index);

export default { partnersData };



// WEBPACK FOOTER //
// ./src/components/partners-list/constants.js